export default "__VITE_ASSET__ToI7Fg____"